<script>
import UserInfoComponent from '@/components/UserInfoComponent'
import RightLayout from '../layouts/rightLayout'
import {RoleFlagCheck} from '@/utils/RoleFlagCheck.js'
import { formatDate, DateUtil } from '@/utils/date.js'

export default {
  data () {
    return {
      // ユーザープロフィール情報
      userProfileModel: {
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        sex: 0,
        birthday: '',
        homeAddress: '',
        homeLat: '',
        homeLng: '',
        homeTelephone: '',
        portableTelephone: null,
        postalcode: '',
        fax: null,
        passengerCost: null,
        note: null
      },
      // ドライバープロフィール情報
      userDriverProfileModel: {
        facePhotoUrl: null,
        driverLicenseDeadline: '',
        joinDate: '',
        accidentFlag: null,
        accidentDetails: null,
        sanctionFlag: null,
        sanctionDetails: null,
        rewardFlag: null,
        driverLicensePhotoUrl1: null,
        driverLicensePhotoUrl2: null
      },
      // 交通事業者プロフィール情報
      userTransportDriverProfileModel: {
        transportId: '',
      },
      // ユーザーアカウント情報
      userAccountModel: {
        roleFlag: '',
        joinDate: '',
        uid: '',
        loginId: '',
        password: ''
      },
      // 会員checkbox
      userCheckbox: false,
      // ドライバーcheckbox
      driverCheckbox: false,
      // 交通事業者checkbox
      transportCheckbox: false,
      // 管理者checkbox
      adminCheckbox: false,
      // 管理者单选按钮
      permissionRadio: null,
      // 登録日 默认：系统当前日期 格式：yyyy年MM月dd日
      inTime: '',
      // ドライバー登録日 默认：系统当前日期 格式：yyyy年MM月dd日
      driverInTime: '',
      // user年龄
      age: 0,
      // 活動年数
      activityYear: '１ヶ月',

      // 生年月日：年
      birthdayYear: 0,
      // 生年月日：月
      birthdayMonth: 0,
      // 生年月日：日
      birthdayDay: 0,
      // 免許証有効期限:年
      driverLicenseDeadlineYear: 0,
      // 免許証有効期限:月
      driverLicenseDeadlineMonth: 0,
      // 免許証有効期限:日
      driverLicenseDeadlineDay: 0

    }
  },
  components: {UserInfoComponent, RightLayout},
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let userInfoDetail = JSON.parse(sessionStorage.getItem('userInfoDetail'))
      // this.userProfileModel.uid = userInfoDetail.uid
      this.userProfileModel.lastName = userInfoDetail.lastName
      this.userProfileModel.firstName = userInfoDetail.firstName
      this.userProfileModel.lastNameKana = userInfoDetail.lastNamekana
      this.userProfileModel.firstNameKana = userInfoDetail.firstNamekana
      this.userProfileModel.sex = userInfoDetail.sex
      this.userProfileModel.birthday = userInfoDetail.birthday
      this.userProfileModel.homeAddress = userInfoDetail.homeAddress
      this.userProfileModel.homeLat = userInfoDetail.homeLat
      this.userProfileModel.homeLng = userInfoDetail.homeLng
      this.userProfileModel.homeTelephone = userInfoDetail.homeTelephone
      this.userProfileModel.portableTelephone = userInfoDetail.portableTelephone
      this.userProfileModel.postalcode = userInfoDetail.postalcode
      this.userProfileModel.fax = userInfoDetail.fax
      this.userProfileModel.passengerCost = userInfoDetail.passengerCost
      this.userProfileModel.note = userInfoDetail.note

      if (RoleFlagCheck.diver(userInfoDetail.roleFlag)) {
        this.userDriverProfileModel.facePhotoUrl = userInfoDetail.facePhotoUrl
        this.userDriverProfileModel.driverLicenseDeadline = userInfoDetail.driverLicenseDeadline
        if (userInfoDetail.joinDate === null) {
          this.userDriverProfileModel.joinDate = formatDate(new Date(), 'yyyy年MM月dd日')
        } else {
          this.userDriverProfileModel.joinDate = userInfoDetail.driverJoinDate
        }
        this.userDriverProfileModel.accidentFlag = userInfoDetail.accidentFlag
        this.userDriverProfileModel.accidentDetails = userInfoDetail.accidentDetails
        this.userDriverProfileModel.sanctionFlag = userInfoDetail.sanctionFlag
        this.userDriverProfileModel.sanctionDetails = userInfoDetail.sanctionDetails
        this.userDriverProfileModel.rewardFlag = userInfoDetail.rewardFlag
        this.userDriverProfileModel.driverLicensePhotoUrl1 = userInfoDetail.driverLicensePhotoUrl1
        this.userDriverProfileModel.driverLicensePhotoUrl2 = userInfoDetail.driverLicensePhotoUrl2
      }

      this.userAccountModel.roleFlag = userInfoDetail.roleFlag
      this.userAccountModel.joinDate = userInfoDetail.joinDate
      this.userAccountModel.uid = userInfoDetail.uid
      this.userAccountModel.loginId = userInfoDetail.loginId
      this.userAccountModel.password = userInfoDetail.password

      this.userCheckbox = RoleFlagCheck.member(userInfoDetail.roleFlag)
      this.driverCheckbox = RoleFlagCheck.diver(userInfoDetail.roleFlag)
      this.transportCheckbox = RoleFlagCheck.transport(userInfoDetail.roleFlag)
      if (RoleFlagCheck.generalManager(userInfoDetail.roleFlag) || RoleFlagCheck.masterManager(userInfoDetail.roleFlag)) {
        this.adminCheckbox = true
      }
      if (RoleFlagCheck.generalManager(userInfoDetail.roleFlag)) {
        this.permissionRadio = 0
      }
      if (RoleFlagCheck.masterManager(userInfoDetail.roleFlag)) {
        this.permissionRadio = 1
      }
      this.inTime = DateUtil.yearMonthDay(userInfoDetail.joinDate)
      if (userInfoDetail.driverJoinDate === null || userInfoDetail.driverJoinDate === '') {
        this.driverInTime = DateUtil.dateToString(new Date())
      } else {
        this.driverInTime = DateUtil.yearMonthDay(userInfoDetail.driverJoinDate)
      }
      this.age = DateUtil.yearCompute(userInfoDetail.birthday)
      if (userInfoDetail.driverJoinDate === null || userInfoDetail.driverJoinDate === '') {
        this.activityYear = '１ヶ月'
      } else {
        this.activityYear = DateUtil.yearMonthCompute(userInfoDetail.driverJoinDate)
      }

      this.birthdayYear = this.getYear(this.userProfileModel.birthday)
      this.birthdayMonth = this.getMonth(this.userProfileModel.birthday)
      this.birthdayDay = this.getDay(this.userProfileModel.birthday)
      this.driverLicenseDeadlineYear = this.getYear(this.userDriverProfileModel.driverLicenseDeadline)
      this.driverLicenseDeadlineMonth = this.getMonth(this.userDriverProfileModel.driverLicenseDeadline)
      this.driverLicenseDeadlineDay = this.getDay(this.userDriverProfileModel.driverLicenseDeadline)

      // this.userProfileModel.password = this.userAccountModel.password
      // 交通事業者取得
      this.userTransportDriverProfileModel.transportId = userInfoDetail.transportId
    },
    getYear (date) {
      if (date !== null && date !== '') {
        let year = date.substr(0, 4)
        return parseInt(year)
      }
    },
    getMonth (date) {
      if (date !== null && date !== '') {
        if (date.charAt(4) === '0') {
          return parseInt(date.charAt(5))
        } else {
          return parseInt(date.substr(4, 2))
        }
      }
    },
    getDay (date) {
      if (date !== null && date !== '') {
        if (date.charAt(6) === '0') {
          return parseInt(date.charAt(7))
        } else {
          return parseInt(date.substr(6, 2))
        }
      }
    }
  }
}
</script>

<template>
<right-layout>
<user-info-component
    :title="'アカウントを編集'"
    :btnName="'保存'"
    :functionFlag="'1'"
    :userProfileModel=userProfileModel
    :userDriverProfileModel=userDriverProfileModel
    :userTransportDriverProfileModel=userTransportDriverProfileModel
    :userAccountModel=userAccountModel
    :userCheckboxs=userCheckbox
    :driverCheckboxs=driverCheckbox
    :adminCheckboxs=adminCheckbox
    :transportCheckboxs=transportCheckbox
    :permissionRadios=permissionRadio
    :inTime=inTime
    :birthdayYear=birthdayYear
    :birthdayMonth=birthdayMonth
    :birthdayDay=birthdayDay
    :driverLicenseDeadlineYear=driverLicenseDeadlineYear
    :driverLicenseDeadlineMonth=driverLicenseDeadlineMonth
    :driverLicenseDeadlineDay=driverLicenseDeadlineDay
    :activityYear=activityYear
    :driverInTime=driverInTime
    ></user-info-component>
</right-layout>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/views/UserEditor.vue